var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewUploadIcon = function SvgNewUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0B4BE",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M10 3v11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0B4BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5 8 5-5 5 5M4 14v2h12v-2"
  })));
};
export { SvgNewUploadIcon as ReactComponent };
export default __webpack_public_path__ + "6c6d078519e3a8e0ca0ce313e414790b.svg";